module.exports = __webpack_public_path__ + "img/deliverytime@2x.06f3ed6.jpg";